<div class="content-container">
  <div class="title-container">
    <h2>12 preguntas que deberías hacerte si estás considerando comprar un camión eléctrico</h2>
    <p>...y las respuestas a tus preguntas!</p>
  </div>

  <div class="flex-container">
    <div class="faq-entry-box" *ngFor="let faqEntry of faqEntrySet" [ngStyle]="faqEntry.styles">
      <p>{{faqEntry.questionSet.length}}</p>
      <h3>{{faqEntry.title}}</h3>
    </div>
  </div>

  <div class="line"></div>
  <div class="arrow"></div>

  <!--<div class="arrow-animation"></div>-->

  <div *ngFor="let faqEntry of faqEntrySet">
    <h3 class="faq-entry-title" [ngStyle]="faqEntry.styles">{{faqEntry.title}}</h3>
    <ol class="faq-entry-list">
      <li *ngFor="let questionEntry of faqEntry.questionSet">
        <h4 [ngClass]="faqEntry.classes['counterClass']"
            (click)="toggleSubtitlesListVisibility($event.currentTarget)">{{questionEntry.title}}</h4>
        <ul class="subtitles-list hide-element">
          <li class="subtitles-list-item" *ngFor="let subtitleEntry of questionEntry.subtitles">
            <h5 [ngClass]="[subtitleEntry.classSwitch ? 'point-down' : 'point-right', 'subtitle-entry-subtitle']"
                (click)="subtitleEntry.classSwitch = !subtitleEntry.classSwitch">{{subtitleEntry.subtitle}}</h5>
            <section [ngClass]="[subtitleEntry.classSwitch ? 'show-text' : 'hide-text', 'subtitle-entry-content']"
                     [innerHTML]="subtitleEntry.content | sanitizeHtml"></section>
          </li>
        </ul>
      </li>
    </ol>
  </div>
</div>

<div class="fill-space"></div>

<div class="screen-bottom-positioning">
  <div class="blue-horizontal-line"></div>
  <app-footer></app-footer>
</div>
